import { eventEmitterService } from '@widgets/shared/services/eventEmitterService'
import { messengerEmojiLoadedEventName } from '@widgets/messenger/const'
import { computed, onBeforeUnmount, onMounted, ref } from '@/composition/vue/compositionApi'
import { getValueFromRefOrGetter } from '@/composition/getValueFromRefOrGetter'
import type { ValueOrRefOrGetter } from '@/types'
import { emojiToHtml, isEmojiLoaded as _isEmojiLoaded } from '@/utils/emojiHelpers'

export const useWidgetTextWithEmoji = (
  text: ValueOrRefOrGetter<string | undefined>,
  emojiSize?: ValueOrRefOrGetter<string | undefined>,
) => {
  const textValue = computed(() => getValueFromRefOrGetter(text))
  const emojiSizeValue = computed(() => getValueFromRefOrGetter(emojiSize))

  const isEmojiLoaded = ref(_isEmojiLoaded())
  let emojiLoadingListenerId = ''

  const textWithEmoji = computed(() => {
    if (!textValue.value) {
      return ''
    }
    const customSize = emojiSizeValue.value ? emojiSizeValue.value : '16px'
    return isEmojiLoaded.value
      ? emojiToHtml(textValue.value, {
          customSize,
          withVerticalAlignCompensation: true,
        })
      : textValue.value
  })

  onMounted(() => {
    if (isEmojiLoaded.value) {
      return
    }
    emojiLoadingListenerId = eventEmitterService.on(messengerEmojiLoadedEventName, () => {
      isEmojiLoaded.value = true
    })
  })

  onBeforeUnmount(() => {
    eventEmitterService.remove(emojiLoadingListenerId)
  })

  return {
    textWithEmoji,
  }
}
